import { Component, Input } from '@angular/core'

@Component({
   selector: 'vc-rounded-card',
   templateUrl: './rounded-card.component.html',
   styleUrl: './rounded-card.component.scss',
   standalone: false,
})
export class VcRoundedCardComponent {
   @Input() cardTitle = ''
   @Input() titleSize = '18px'
   @Input() colorClass: 'v-darkgreen' | 'v-green' | 'v-turquoise' | 'v-red' | 'v-blue' | 'v-purple' | 'v-white' | 'v-default' = 'v-default'
}
